import type {Store} from 'redux';
import {initFavorites} from '~/GalleryPB/reducers/favorites';
import {setActiveFilters} from '~/GalleryPB/reducers/filters';
import {initGalleryData, updateActiveFilters} from '~/GalleryPB/reducers/galleryData';
import type {GalleryData} from '~/GalleryPB/types/gallery';

export const getGalleryDataCallback = (store: Store) => (data: GalleryData) => {
  const params = new URLSearchParams(window.location.search);

  let pageDisplayName =
    params.get('query') || // get query from URL if it exists
    window.seo_display_name ||
    data.displayName ||
    data.searchText || // only one of data.displayName and data.searchText will exist
    ''; // finally, fall back to an empty string if NONE of these exist (super edge case)

  const previousCurrentPage = parseInt(params.get('page') || '1', 10) || 1;

  const urlPieces = window.location.pathname.split('/');
  if (urlPieces.includes('favorites')) {
    pageDisplayName = 'My Favorites';
  }

  // Save filter data in Redux
  store.dispatch(initGalleryData({...data, pageDisplayName, previousCurrentPage}));
  const urlFilters = params.getAll('active_filter');

  const filtersToSubmit = urlFilters
    ? urlFilters.map((f) => {
        const pair = f.split(',');
        return {
          filterSection: pair[0],
          filterName: pair[1],
          on: true,
        };
      })
    : [];

  filtersToSubmit.forEach((f) =>
    store.dispatch(
      updateActiveFilters({
        sectionName: f.filterSection,
        filterName: f.filterName,
        apiResponse: data,
      })
    )
  );

  // Extract the user's favorites
  const favoritedTemplates: string[] = [];
  const allTemplates = [...data.freeTemplates, ...data.premiumTemplates];
  allTemplates.forEach((t) => {
    if (t.favorite) favoritedTemplates.push(t.templateId);
  });

  // Save the user's favorites
  store.dispatch(initFavorites(favoritedTemplates));

  store.dispatch(setActiveFilters(filtersToSubmit));
  window.scrollTo(0, 0);
};
